<div class="filter" [class.filter--compact]="compact" [class.filter--full]="!compact"
     [class.filter--enabled]="checkbox.checked">
  <mat-checkbox #checkbox [(ngModel)]="filter.enabled" aria-label="{{ label }}" class="filter__checkbox">
    <div class="filter__header">
      <mat-icon *ngIf="icon || fontIcon || svgIcon" [fontSet]="fontSet" [fontIcon]="fontIcon" [svgIcon]="svgIcon"
                class="filter__icon" [innerHTML]="icon">
      </mat-icon>
      <span class="filter__label">{{ label }}</span>
    </div>
  </mat-checkbox>
</div>
